// src/pages/CRMQualityPage.jsx
// C3.2.5 — Calidad Comercial PRO estilo Lead Web ORBIS
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import { API_BASE } from "../config/orbisConfig";


const PRODUCT_LINES = [
    "",
    "ORBIS PMO",
    "Gestión institucional",
    "CRM institucional",
    "Proyectos y compromisos",
    "Eventos institucionales",
    "Directorio estratégico",
    "Otro"
];

async function safeJson(url, options = {}) {
    const res = await fetch(url, options);
    const text = await res.text();
    let data = null;
    try { data = text ? JSON.parse(text) : null; }
    catch { throw new Error(`Respuesta no JSON (${res.status}): ${text.slice(0, 220)}`); }
    if (!res.ok || data?.success === false || data?.ok === false) throw new Error(data?.error || data?.detail || `HTTP ${res.status}`);
    return data;
}

function asArray(data) {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.rows)) return data.rows;
    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data?.items)) return data.items;
    return [];
}

function n(value) {
    const x = Number(value || 0);
    return Number.isFinite(x) ? x : 0;
}

function pct(value) {
    return `${Math.round(n(value))}%`;
}

function qualityTone(level) {
    if (level === "excelente") return "green";
    if (level === "buena") return "blue";
    if (level === "atencion") return "amber";
    return "red";
}

function Badge({ children, tone = "gray" }) {
    const tones = {
        gray: "border-[#24537a] bg-[#0f2d48] text-[#d9e8f5]",
        blue: "border-[#0ea5e9]/50 bg-[#0b3552] text-[#7dd3fc]",
        green: "border-[#10b981]/40 bg-[#0b3a36] text-[#7cebd0]",
        amber: "border-[#d4af37]/45 bg-[#3a3110] text-[#f6d76b]",
        red: "border-[#ef4444]/40 bg-[#38161c] text-[#fca5a5]",
        orange: "border-[#f97316]/40 bg-[#3b2413] text-[#fdba74]",
        purple: "border-[#8b5cf6]/40 bg-[#24163d] text-[#c4b5fd]",
    };
    return <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-[10px] font-semibold tracking-wide ${tones[tone] || tones.gray}`}>{children}</span>;
}

function KpiCard({ title, value, subtitle, tone = "default", onClick }) {
    const tones = {
        default: "border-[#0b4d78] bg-[#08233D]",
        blue: "border-[#0ea5e9]/45 bg-[#0b2740]",
        red: "border-[#ef4444]/40 bg-[#2b1117]",
        amber: "border-[#d4af37]/45 bg-[#3a3110]",
        green: "border-[#10b981]/40 bg-[#0a332e]",
        purple: "border-[#8b5cf6]/40 bg-[#24163d]",
        slate: "border-[#24537a] bg-[#08233D]",
    };
    return (
        <button
            type="button"
            onClick={onClick}
            className={`text-left rounded-[22px] border p-4 shadow-[0_12px_30px_rgba(0,0,0,0.18)] transition hover:-translate-y-0.5 hover:border-[#d4af37] ${tones[tone] || tones.default}`}
        >
            <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#8fb9da]">{title}</div>
            <div className="text-3xl font-black text-white mt-2">{value}</div>
            {subtitle ? <div className="text-[10px] text-[#9fc4df] mt-1">{subtitle}</div> : null}
        </button>
    );
}

function Section({ title, subtitle, children }) {
    return (
        <div className="quality-card rounded-[24px] overflow-hidden">
            <div className="px-5 py-4 border-b border-[#0b4d78] bg-[#031425]">
                <h3 className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#d4af37]">{title}</h3>
                {subtitle ? <p className="text-[11px] text-[#9fc4df] mt-1">{subtitle}</p> : null}
            </div>
            {children}
        </div>
    );
}

function ProgressBar({ value, tone = "blue" }) {
    const colors = {
        red: "linear-gradient(90deg, #ef4444 0%, #f87171 100%)",
        amber: "linear-gradient(90deg, #d4af37 0%, #facc15 100%)",
        blue: "linear-gradient(90deg, #0ea5e9 0%, #38bdf8 100%)",
        green: "linear-gradient(90deg, #10b981 0%, #34d399 100%)",
    };
    const width = Math.max(0, Math.min(100, n(value)));
    return (
        <div className="h-2.5 rounded-full bg-[#0b2740] overflow-hidden border border-[#0b4d78]">
            <div className="h-full rounded-full" style={{ width: `${width}%`, background: colors[tone] || colors.blue }} />
        </div>
    );
}

function QualityStyle() {
    return <style>{`
    .quality-crm{color:#f5fbff}
    .quality-crm select option{background:#061a2f;color:white}
    .quality-crm .quality-hero{background:linear-gradient(135deg,#03111f 0%,#031a2f 55%,#04223d 100%);border:1px solid rgba(11,93,140,.8);box-shadow:0 20px 45px rgba(0,0,0,.28)}
    .quality-crm .quality-card{border:1px solid rgba(11,93,140,.82);background:#04192b;box-shadow:0 12px 30px rgba(0,0,0,.24)}
    .quality-crm .quality-actions-bar{background:#031425;border:1px solid #0b4d78;border-radius:22px}
    .quality-crm .quality-btn{border:1px solid #24537a;background:#0b2740;color:#f5fbff;border-radius:999px;padding:10px 14px;font-size:12px;font-weight:700}
    .quality-crm .quality-btn:hover{background:#10324f;border-color:#d4af37}
    .quality-crm .quality-btn-primary{background:#d4af37;color:#081a2b;border-color:#d4af37}
    .quality-crm .quality-btn-primary:hover{background:#e8c457}
    .quality-crm table{border-collapse:separate;border-spacing:0;background:#061a2f}
    .quality-crm table tbody tr{transition:background .18s ease, box-shadow .18s ease;background:#08233d!important}
    .quality-crm table tbody tr:nth-child(even){background:#092a49!important}
    .quality-crm table tbody tr:hover{background:rgba(56,189,248,.075)!important;box-shadow:inset 3px 0 0 #d4af37}
    .quality-crm table tbody td{border-top:1px solid #24587c;background:transparent!important;color:#f5fbff}
    .quality-crm table thead th{position:sticky;top:0;z-index:10;background:#061a2f!important;color:#8fb9da;border-bottom:1px solid #24587c;text-transform:uppercase;letter-spacing:.13em}
    .quality-crm .input-pro{width:100%;border:1px solid #0b5f91;border-radius:.85rem;padding:.65rem .75rem;font-size:12px;outline:none;background:#0b2740;color:#fff}
    .quality-crm .input-pro::placeholder{color:#7ea8c7}
    .quality-crm .input-pro:focus{border-color:#d4af37;box-shadow:0 0 0 2px rgba(212,175,55,.18)}
    .quality-crm .label-pro{display:block;font-size:11px;color:#8fb9da;margin-bottom:6px;font-weight:700;text-transform:uppercase;letter-spacing:.14em}
    .quality-crm .quality-scroll-top{overflow-x:auto;overflow-y:hidden;height:14px;border:1px solid #24587c;border-radius:999px;background:#061a2f;margin:0 12px 8px 12px}
    .quality-crm .quality-scroll-spacer{height:1px;min-width:1400px}
    .quality-crm .quality-scroll{overflow:auto;max-height:68vh}
    .quality-crm .quality-scroll::-webkit-scrollbar,.quality-crm .quality-scroll-top::-webkit-scrollbar{height:10px;width:10px}
    .quality-crm .quality-scroll::-webkit-scrollbar-track,.quality-crm .quality-scroll-top::-webkit-scrollbar-track{background:#061a2f;border-radius:999px}
    .quality-crm .quality-scroll::-webkit-scrollbar-thumb,.quality-crm .quality-scroll-top::-webkit-scrollbar-thumb{background:#2b638e;border-radius:999px}
    .quality-crm .quality-scroll::-webkit-scrollbar-thumb:hover,.quality-crm .quality-scroll-top::-webkit-scrollbar-thumb:hover{background:#d4af37}
    .quality-crm .row-main{font-weight:700;color:#fff}
    .quality-crm .row-sub{color:#9fc4df;font-size:11px}
  `}</style>;
}

export default function CRMQualityPage() {
    const navigate = useNavigate();
    const topScrollRef = useRef(null);
    const bottomScrollRef = useRef(null);
    const [summary, setSummary] = useState({});
    const [items, setItems] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [pipelines, setPipelines] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [filters, setFilters] = useState({ product_line: "", campaign_id: "", pipeline_id: "", account_id: "", quality_level: "" });
    const [sortConfig, setSortConfig] = useState({ key: "score", direction: "asc" });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    function buildQuery(extra = {}) {
        const merged = { ...filters, ...extra };
        const params = new URLSearchParams();
        Object.entries(merged).forEach(([key, value]) => {
            if (key === "quality_level") return;
            if (value !== undefined && value !== null && value !== "") params.set(key, value);
        });
        return params.toString();
    }

    async function loadCatalogs() {
        const [campData, pipeData, accData] = await Promise.all([
            safeJson(`${API_BASE}/campaigns_list.php?active_only=1`),
            safeJson(`${API_BASE}/pipelines_list.php?active_only=1`),
            safeJson(`${API_BASE}/accounts_list.php`),
        ]);
        setCampaigns(asArray(campData));
        setPipelines(asArray(pipeData));
        setAccounts(asArray(accData));
    }

    async function loadQuality(extra = {}) {
        try {
            setLoading(true);
            setError("");
            const data = await safeJson(`${API_BASE}/crm_commercial_quality.php?${buildQuery(extra)}`);
            setSummary(data.summary || {});
            setItems(Array.isArray(data.items) ? data.items : []);
        } catch (err) {
            console.error(err);
            setError(err.message || "No se pudo cargar la calidad comercial.");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        async function boot() {
            await loadCatalogs();
            await loadQuality();
        }
        boot();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleFilterChange(e) {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    }

    function clearFilters() {
        const reset = { product_line: "", campaign_id: "", pipeline_id: "", account_id: "", quality_level: "" };
        setFilters(reset);
        loadQuality(reset);
    }

    function requestSort(key) {
        setSortConfig((prev) => ({ key, direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc" }));
    }

    function SortButton({ sortKey, children }) {
        const active = sortConfig.key === sortKey;
        return (
            <button type="button" onClick={() => requestSort(sortKey)} className={`inline-flex items-center gap-1 hover:text-[#d4af37] ${active ? "text-[#d4af37]" : ""}`}>
                <span>{children}</span>
                <span className="text-[10px]">{active ? (sortConfig.direction === "asc" ? "▲" : "▼") : "↕"}</span>
            </button>
        );
    }

    const filteredItems = useMemo(() => {
        let rows = [...items];
        if (filters.quality_level) rows = rows.filter((r) => r.quality_level === filters.quality_level);
        const direction = sortConfig.direction === "asc" ? 1 : -1;
        rows.sort((a, b) => {
            let av = "", bv = "";
            if (sortConfig.key === "score") { av = n(a.quality_score); bv = n(b.quality_score); }
            else if (sortConfig.key === "level") { av = a.quality_level || ""; bv = b.quality_level || ""; }
            else if (sortConfig.key === "account") { av = a.account_name || ""; bv = b.account_name || ""; }
            else if (sortConfig.key === "stage") { av = a.stage_name || ""; bv = b.stage_name || ""; }
            else { av = a.name || ""; bv = b.name || ""; }
            if (typeof av === "number" || typeof bv === "number") return (n(av) - n(bv)) * direction;
            return String(av).localeCompare(String(bv), "es", { numeric: true, sensitivity: "base" }) * direction;
        });
        return rows;
    }, [items, filters.quality_level, sortConfig]);

    const executiveTone = n(summary.average_score) >= 75 ? "green" : n(summary.average_score) >= 50 ? "amber" : "red";

    function opportunityUrl(id) { return `/opportunities/${id}/edit`; }
    function agendaUrl(row) {
        const params = new URLSearchParams();
        if (row?.id) params.set("opportunity_id", row.id);
        if (row?.account_id) params.set("account_id", row.account_id);
        params.set("new_activity", "1");
        return `/agenda?${params.toString()}`;
    }

    function syncHorizontalScroll(source) {
        const top = topScrollRef.current;
        const bottom = bottomScrollRef.current;
        if (!top || !bottom) return;

        if (source === "top") {
            bottom.scrollLeft = top.scrollLeft;
        } else {
            top.scrollLeft = bottom.scrollLeft;
        }
    }

    return (
        <MainLayout>
            <QualityStyle />
            <div className="quality-crm min-h-screen bg-[#041426] px-3 py-6 md:px-6 md:py-8"><div className="mx-auto max-w-[1500px] space-y-6">
                <div className="quality-hero rounded-[28px] px-6 py-6 md:px-7 md:py-7 flex flex-col xl:flex-row xl:items-start xl:justify-between gap-4">
                    <div>
                        <p className="mb-3 inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] text-[#D4AF37]"><span className="h-px w-10 bg-[#D4AF37]" />CRM Comercial</p><h2 className="text-3xl md:text-4xl font-black tracking-tight text-white">Calidad Comercial CRM</h2>
                        <p className="text-sm md:text-base text-[#d7e8f6] max-w-3xl leading-relaxed">Evalúa la madurez de captura comercial: contacto clave, siguiente acción, actividad, valor piloto y potencial mensual.</p>
                    </div>
                    <div className="flex flex-wrap gap-2 text-xs">
                        <button type="button" onClick={() => navigate("/crm-dashboard")} className="quality-btn">Dashboard CRM</button>
                        <button type="button" onClick={() => navigate("/opportunities")} className="quality-btn">Oportunidades</button>
                        <button type="button" onClick={() => navigate("/agenda")} className="quality-btn">Agenda</button>
                        <button type="button" onClick={() => loadQuality()} className="quality-btn quality-btn-primary">Recargar</button>
                    </div>
                </div>

                {error ? <div className="text-xs rounded-xl px-4 py-3 border bg-[#2b1117] text-[#fca5a5] border-[#ef4444]/40">{error}</div> : null}

                <div className={`rounded-[24px] border shadow-[0_12px_30px_rgba(0,0,0,0.24)] p-5 ${executiveTone === "green" ? "bg-[#0a332e] border-[#10b981]/40" : executiveTone === "amber" ? "bg-[#3a3110] border-[#d4af37]/45" : "bg-[#2b1117] border-[#ef4444]/40"}`}>
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
                        <div>
                            <div className="text-[11px] text-[#9fc4df]">Score promedio de calidad comercial</div>
                            <h3 className="text-2xl font-black text-white mt-0.5">{summary.average_score || 0}/100</h3>
                            <p className="text-xs text-[#d7e8f6] mt-1 max-w-4xl">Una oportunidad comercial madura debe tener cuenta, contacto clave, próxima acción, actividad vinculada, valor piloto y potencial mensual.</p>
                        </div>
                        <div className="w-full lg:w-80">
                            <ProgressBar value={summary.average_score || 0} tone={executiveTone} />
                            <div className="flex justify-between text-[10px] text-[#9fc4df] mt-1"><span>Crítica</span><span>Excelente</span></div>
                        </div>
                    </div>
                </div>

                <div className="quality-card rounded-[24px] p-5">
                    <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-6 gap-3 text-xs">
                        <div><label className="label-pro">Producto</label><select name="product_line" value={filters.product_line} onChange={handleFilterChange} className="input-pro">{PRODUCT_LINES.map((p) => <option key={p || "all"} value={p}>{p || "Todos"}</option>)}</select></div>
                        <div><label className="label-pro">Campaña</label><select name="campaign_id" value={filters.campaign_id} onChange={handleFilterChange} className="input-pro"><option value="">Todas</option>{campaigns.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select></div>
                        <div><label className="label-pro">Pipeline</label><select name="pipeline_id" value={filters.pipeline_id} onChange={handleFilterChange} className="input-pro"><option value="">Todos</option>{pipelines.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</select></div>
                        <div><label className="label-pro">Cuenta</label><select name="account_id" value={filters.account_id} onChange={handleFilterChange} className="input-pro"><option value="">Todas</option>{accounts.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}</select></div>
                        <div><label className="label-pro">Calidad</label><select name="quality_level" value={filters.quality_level} onChange={handleFilterChange} className="input-pro"><option value="">Todas</option><option value="critica">Crítica</option><option value="atencion">Atención</option><option value="buena">Buena</option><option value="excelente">Excelente</option></select></div>
                        <div className="flex items-end gap-2"><button type="button" onClick={clearFilters} className="quality-btn">Limpiar</button><button type="button" onClick={() => loadQuality()} className="quality-btn quality-btn-primary">Aplicar</button></div>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-3">
                    <KpiCard title="Score promedio" value={`${summary.average_score || 0}/100`} subtitle="Calidad comercial" tone={executiveTone} />
                    <KpiCard title="Con contacto" value={pct(summary.contact_rate)} subtitle={`${summary.with_contact || 0}/${summary.total || 0} oportunidades`} tone={n(summary.contact_rate) >= 70 ? "green" : "amber"} />
                    <KpiCard title="Con próxima acción" value={pct(summary.next_action_rate)} subtitle={`${summary.with_next_action || 0}/${summary.total || 0} oportunidades`} tone={n(summary.next_action_rate) >= 70 ? "green" : "red"} />
                    <KpiCard title="Con valor piloto" value={pct(summary.pilot_value_rate)} subtitle={`${summary.with_pilot_value || 0}/${summary.total || 0} oportunidades`} tone={n(summary.pilot_value_rate) >= 70 ? "green" : "amber"} />
                    <KpiCard title="Con actividad" value={pct(summary.activity_rate)} subtitle={`${summary.with_activity || 0}/${summary.total || 0} oportunidades`} tone={n(summary.activity_rate) >= 70 ? "green" : "amber"} />
                    <KpiCard title="Críticas" value={summary.critical || 0} subtitle="Requieren captura base" tone="red" onClick={() => setFilters((p) => ({ ...p, quality_level: "critica" }))} />
                    <KpiCard title="Atención" value={summary.attention || 0} subtitle="Faltan datos clave" tone="amber" onClick={() => setFilters((p) => ({ ...p, quality_level: "atencion" }))} />
                    <KpiCard title="Buenas" value={summary.good || 0} subtitle="Captura aceptable" tone="blue" onClick={() => setFilters((p) => ({ ...p, quality_level: "buena" }))} />
                    <KpiCard title="Excelentes" value={summary.excellent || 0} subtitle="Alta madurez" tone="green" onClick={() => setFilters((p) => ({ ...p, quality_level: "excelente" }))} />
                    <KpiCard title="Con actividad futura" value={pct(summary.future_activity_rate)} subtitle="Seguimiento programado" tone={n(summary.future_activity_rate) >= 70 ? "green" : "amber"} />
                </div>

                {loading ? <div className="text-sm text-[#9fc4df] quality-card rounded-[24px] p-5">Cargando calidad comercial.</div> : null}

                <Section title="Matriz de calidad por oportunidad" subtitle="Score, faltantes y acciones recomendadas.">
                    <div
                        ref={topScrollRef}
                        className="quality-scroll-top"
                        onScroll={() => syncHorizontalScroll("top")}
                        aria-hidden="true"
                    >
                        <div className="quality-scroll-spacer" />
                    </div>

                    <div
                        ref={bottomScrollRef}
                        className="quality-scroll"
                        onScroll={() => syncHorizontalScroll("bottom")}
                    >
                        <table className="min-w-[1400px] w-full text-xs">
                            <thead><tr className="text-left text-[11px] font-semibold"><th className="px-3 py-2"><SortButton sortKey="score">Score</SortButton></th><th className="px-3 py-2"><SortButton sortKey="name">Oportunidad</SortButton></th><th className="px-3 py-2"><SortButton sortKey="account">Cuenta</SortButton></th><th className="px-3 py-2"><SortButton sortKey="stage">Etapa</SortButton></th><th className="px-3 py-2">Checklist</th><th className="px-3 py-2">Faltantes</th><th className="px-3 py-2 text-right">Acciones</th></tr></thead>
                            <tbody>
                                {filteredItems.length === 0 ? <tr><td colSpan={7} className="px-3 py-6 text-center text-[#9fc4df]">Sin oportunidades con estos filtros.</td></tr> : filteredItems.map((row) => (
                                    <tr key={row.id} className="">
                                        <td className="px-3 py-2"><div className="font-semibold text-white">{row.quality_score}/100</div><div className="mt-1 w-28"><ProgressBar value={row.quality_score} tone={qualityTone(row.quality_level)} /></div><div className="mt-1"><Badge tone={qualityTone(row.quality_level)}>{row.quality_level}</Badge></div></td>
                                        <td className="px-3 py-2"><button type="button" onClick={() => navigate(opportunityUrl(row.id))} className="font-semibold text-white hover:text-[#d4af37] text-left">{row.name}</button><div className="text-[11px] text-[#9fc4df]">{row.product_line || "Sin producto"}</div></td>
                                        <td className="px-3 py-2">{row.account_name || "Sin cuenta"}</td>
                                        <td className="px-3 py-2"><Badge tone="blue">{row.stage_name || "Sin etapa"}</Badge></td>
                                        <td className="px-3 py-2"><div className="flex flex-wrap gap-1"><Badge tone={Number(row.has_account) ? "green" : "red"}>Cuenta</Badge><Badge tone={Number(row.has_contact) ? "green" : "red"}>Contacto</Badge><Badge tone={Number(row.has_next_action) ? "green" : "red"}>Próx.</Badge><Badge tone={Number(row.has_pilot_value) ? "green" : "amber"}>Piloto</Badge><Badge tone={Number(row.has_monthly_potential) ? "green" : "amber"}>Mensual</Badge><Badge tone={Number(row.has_activity) ? "green" : "red"}>Actividad</Badge></div></td>
                                        <td className="px-3 py-2">{Array.isArray(row.missing_items) && row.missing_items.length ? <div className="flex flex-wrap gap-1">{row.missing_items.slice(0, 6).map((item) => <Badge key={item} tone="amber">{item}</Badge>)}</div> : <Badge tone="green">Completa</Badge>}</td>
                                        <td className="px-3 py-2 text-right"><div className="flex flex-wrap justify-end gap-1"><button type="button" onClick={() => navigate(opportunityUrl(row.id))} className="quality-btn">Abrir</button><button type="button" onClick={() => navigate(agendaUrl(row))} className="quality-btn quality-btn-primary">Actividad</button>{!Number(row.has_pilot_value) || !Number(row.has_monthly_potential) ? <button type="button" onClick={() => navigate(opportunityUrl(row.id))} className="quality-btn quality-btn-primary">Valor</button> : null}</div></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Section>
            </div>
            </div>
        </MainLayout>
    );
}
